// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle10 from "../../randing/RandingStyle10";

function Randing014({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle10
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/014/241118_01.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/014/241118_02.jpg`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/014/241118_03.jpg`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/014/241118_04.jpg`}
      companyName="청춘플란트치과"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/014/241118_05.jpg`}
    />
  );
}

export default Randing014;
